{
  "replaceMessage": "ファイルをドロップして置換"
}
